'use client';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface ListProps {
    children: ReactNode;
    className?: string;
    ordered?: boolean;
}

const List = ({
    children,
    className = '',
    ordered = false
}: ListProps) => {
    const Tag = ordered ? 'ol' : 'ul'

    return (
        <Tag className={twMerge('list-none', className)}>
            {children}
        </Tag>
    )
}

export default List 